import { infiniteQueryOptions } from "@tanstack/react-query";

import { fetchNotifications, getNextNotificationsPageParam } from "./fetchNotifications";
import { notificationQueryKeys } from "./query-keys";
import { NOTIFICATION_STALE_TIME_MS } from "../constants";
import type { NotificationFilters } from "../types";

export function notificationPageQueryOptions(filters: NotificationFilters) {
  return infiniteQueryOptions({
    queryKey: notificationQueryKeys.page(filters),
    initialPageParam: 1,
    queryFn: ({ pageParam }) => fetchNotifications(pageParam, filters),
    getNextPageParam: getNextNotificationsPageParam,
    staleTime: NOTIFICATION_STALE_TIME_MS,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
}
